module.exports = __webpack_public_path__ + "static/media/team_building.dbb473c2.png";